// import React, { useEffect, useState } from "react";
// import { Container, Row, Col, Form, Button } from "react-bootstrap";
// import { Formik } from "formik";
// import * as Yup from "yup";
// import { toast, ToastContainer } from "react-toastify";
// import "./Jilareport.css";
// import "react-toastify/dist/ReactToastify.css";
// import { useDispatch, useSelector } from "react-redux";
// import fieldLabels from "./FiledLabels";
// import {
//   fetchVibhagList,
//   fetchFormDataByJila,
//   updateReportingForm,
//   clearFormData,
// } from "../redux/slice/JilaReportSlice";
// import { JilaTranslation, VibhagTranslation } from "./Fileds";
// import OverlayTrigger from "react-bootstrap/OverlayTrigger";
// import Tooltip from "react-bootstrap/Tooltip";

// const tableThStyle = {
//   border: "1px solid #222",
//   padding: "6px 10px",
//   background: "#e6e6e6",
//   fontWeight: "bold",
//   textAlign: "center",
//   fontSize: "14px",
//   verticalAlign: "middle",
//   whiteSpace: "nowrap",
// };
// const tableTdStyle = {
//   border: "1px solid #222",
//   padding: "4px 6px",
//   textAlign: "center",
//   fontSize: "15px",
//   verticalAlign: "middle",
//   background: "#fff",
// };

// const Jilareport = () => {
//   const dispatch = useDispatch();
//   const user = useSelector((state) => state.auth.user);
//   const language = useSelector((state) => state.language.language);

//   const vibhagList = useSelector((state) => state.jilareport.vibhagList);
//   const formData = useSelector((state) => state.jilareport.formData);
//   const userType = user?.user_type || "Guest";

//   const [selectedVibhag, setSelectedVibhag] = useState("");
//   const [selectedJila, setSelectedJila] = useState("");
//   const [jilaList, setJilaList] = useState();

//   useEffect(() => {
//     if (userType === "prant" || userType === "vibhag") {
//       dispatch(fetchVibhagList());
//     }
//   }, [dispatch, userType]);

//   useEffect(() => {
//     dispatch(clearFormData());
//     if (selectedJila) {
//       console.log("selectedJila", fetchFormDataByJila);

//       dispatch(fetchFormDataByJila(selectedJila));
//     } else {
//       dispatch(clearFormData());
//     }
//   }, [dispatch, selectedJila]);

//   useEffect(() => {
//     setSelectedJila("");
//     dispatch(clearFormData());
//   }, [dispatch, selectedVibhag]);

//   const validationSchema = Yup.object({
//     mahanagar: Yup.object({
//       zila_sam_mahanagar_bhag_sankhya: Yup.number().required(
//         "This field is required"
//       ),
//       sewa_basti_sankhya: Yup.number().required("This field is required"),
//       sewa_kary_yukt_sewa_basti: Yup.number().required(
//         "This field is required"
//       ),
//       vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya: Yup.number().required(
//         "This field is required"
//       ),
//       sewa_basti_palak_shakha_w_milan_sankhya: Yup.number().required(
//         "This field is required"
//       ),
//       sewa_karyakarta_yukt_shakha_w_milan_sankhya: Yup.number().required(
//         "This field is required"
//       ),
//       kul_sewa_karyakarta: Yup.number().required("This field is required"),
//       mahanagar_mein_kul_sewa_kary: Yup.number().required(
//         "This field is required"
//       ),
//       masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya:
//         Yup.number().required("This field is required"),
//       // NEW FIELDS
//       total_metropolitan_cities: Yup.number().required(
//         "This field is required"
//       ),
//       functional_metropolitan_cities: Yup.number().required(
//         "This field is required"
//       ),
//     }),
//     jilaKendra: Yup.object({
//       zila_sam_mahanagar_bhag_sankhya: Yup.number().required(
//         "This field is required"
//       ),
//       sewa_basti_sankhya: Yup.number().required("This field is required"),
//       sewa_kary_yukt_sewa_basti: Yup.number().required(
//         "This field is required"
//       ),
//       vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya: Yup.number().required(
//         "This field is required"
//       ),
//       sewa_basti_palak_shakha_w_milan_sankhya: Yup.number().required(
//         "This field is required"
//       ),
//       sewa_karyakarta_yukt_shakha_w_milan_sankhya: Yup.number().required(
//         "This field is required"
//       ),
//       kul_sewa_karyakarta: Yup.number().required("This field is required"),
//       mahanagar_mein_kul_sewa_kary: Yup.number().required(
//         "This field is required"
//       ),
//       masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya:
//         Yup.number().required("This field is required"),
//       // NEW FIELDS
//       total_blocks: Yup.number().required("This field is required"),
//       blocks_with_services: Yup.number().required("This field is required"),
//     }),
//     anyaNagar: Yup.object({
//       zila_sam_mahanagar_bhag_sankhya: Yup.number().required(
//         "This field is required"
//       ),
//       sewa_basti_sankhya: Yup.number().required("This field is required"),
//       sewa_kary_yukt_sewa_basti: Yup.number().required(
//         "This field is required"
//       ),
//       vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya: Yup.number().required(
//         "This field is required"
//       ),
//       sewa_basti_palak_shakha_w_milan_sankhya: Yup.number().required(
//         "This field is required"
//       ),
//       sewa_karyakarta_yukt_shakha_w_milan_sankhya: Yup.number().required(
//         "This field is required"
//       ),
//       kul_sewa_karyakarta: Yup.number().required("This field is required"),
//       mahanagar_mein_kul_sewa_kary: Yup.number().required(
//         "This field is required"
//       ),
//       masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya:
//         Yup.number().required("This field is required"),
//     }),
//     villagesOver5000: Yup.object({
//       total_villages: Yup.number().required("This field is required"),
//       business_and_farming_villages: Yup.number().required(
//         "This field is required"
//       ),
//       service_work_villages: Yup.number().required("This field is required"),
//       total_service_work: Yup.number().required("This field is required"),
//       // NEW FIELDS
//       service_settlements_among_them: Yup.number().required(
//         "This field is required"
//       ),
//       branches_meetings_with_service_workers: Yup.number().required(
//         "This field is required"
//       ),
//       total_service_workers_in_villages: Yup.number().required(
//         "This field is required"
//       ),
//       monthly_service_settlement_contact_branches: Yup.number().required(
//         "This field is required"
//       ),
//     }),
//     villagesUnder5000: Yup.object({
//       service_work_villages: Yup.number().required("This field is required"),
//       total_service_work: Yup.number().required("This field is required"),
//     }),
// form02: Yup.object({
//   seva_sanskar_1: Yup.number().required("This field is required"),
//   seva_sanskar_2: Yup.number().required("This field is required"),
//   august_september: Yup.number().required("This field is required"),
//   branches_visiting_6_plus: Yup.number().required("This field is required"),
//   branches_conducting_service_activities: Yup.number().required(
//     "This field is required"
//   ),
//   number_of_service_activities_by_branch: Yup.number().required(
//     "This field is required"
//   ),
//   service_initiative_branch: Yup.number().required(
//     "This field is required"
//   ),
// }),
//   });

//   const initialValues = {
//     mahanagar: {
//       zila_sam_mahanagar_bhag_sankhya:
//         formData?.mahanagar?.zila_sam_mahanagar_bhag_sankhya || "",
//       sewa_basti_sankhya: formData?.mahanagar?.sewa_basti_sankhya || "",
//       sewa_kary_yukt_sewa_basti:
//         formData?.mahanagar?.sewa_kary_yukt_sewa_basti || "",
//       vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya:
//         formData?.mahanagar?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya ||
//         "",
//       sewa_basti_palak_shakha_w_milan_sankhya:
//         formData?.mahanagar?.sewa_basti_palak_shakha_w_milan_sankhya || "",
//       sewa_karyakarta_yukt_shakha_w_milan_sankhya:
//         formData?.mahanagar?.sewa_karyakarta_yukt_shakha_w_milan_sankhya || "",
//       kul_sewa_karyakarta: formData?.mahanagar?.kul_sewa_karyakarta || "",
//       mahanagar_mein_kul_sewa_kary:
//         formData?.mahanagar?.mahanagar_mein_kul_sewa_kary || "",
//       masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya:
//         formData?.mahanagar
//           ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya || "",
//       // NEW FIELDS
//       total_metropolitan_cities:
//         formData?.mahanagar?.total_metropolitan_cities || "",
//       functional_metropolitan_cities:
//         formData?.mahanagar?.functional_metropolitan_cities || "",
//     },
//     jilaKendra: {
//       zila_sam_mahanagar_bhag_sankhya:
//         formData?.mahanagar?.zila_sam_mahanagar_bhag_sankhya || "",
//       sewa_basti_sankhya: formData?.mahanagar?.sewa_basti_sankhya || "",
//       sewa_kary_yukt_sewa_basti:
//         formData?.mahanagar?.sewa_kary_yukt_sewa_basti || "",
//       vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya:
//         formData?.mahanagar?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya ||
//         "",
//       sewa_basti_palak_shakha_w_milan_sankhya:
//         formData?.mahanagar?.sewa_basti_palak_shakha_w_milan_sankhya || "",
//       sewa_karyakarta_yukt_shakha_w_milan_sankhya:
//         formData?.mahanagar?.sewa_karyakarta_yukt_shakha_w_milan_sankhya || "",
//       kul_sewa_karyakarta: formData?.mahanagar?.kul_sewa_karyakarta || "",
//       mahanagar_mein_kul_sewa_kary:
//         formData?.mahanagar?.mahanagar_mein_kul_sewa_kary || "",
//       masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya:
//         formData?.mahanagar
//           ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya || "",
//       // NEW FIELDS
//       total_blocks: formData?.jilaKendra?.total_blocks || "",
//       blocks_with_services: formData?.jilaKendra?.blocks_with_services || "",
//     },
//     anyaNagar: {
//       zila_sam_mahanagar_bhag_sankhya:
//         formData?.anyaNagar?.zila_sam_anya_nagar_bhag_sankhya || "",
//       sewa_basti_sankhya: formData?.anyaNagar?.inmein_sewa_basti_sankhya || "",
//       sewa_kary_yukt_sewa_basti:
//         formData?.anyaNagar?.sewa_kary_yukt_sewa_basti || "",
//       vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya:
//         formData?.anyaNagar?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya ||
//         "",
//       sewa_basti_palak_shakha_w_milan_sankhya:
//         formData?.anyaNagar?.sewa_basti_palak_shakha_w_milan_sankhya || "",
//       sewa_karyakarta_yukt_shakha_w_milan_sankhya:
//         formData?.anyaNagar?.sewa_karyakarta_yukt_shakha_w_milan_sankhya || "",
//       kul_sewa_karyakarta: formData?.anyaNagar?.kul_sewa_karyakarta || "",
//       mahanagar_mein_kul_sewa_kary:
//         formData?.anyaNagar?.anya_nagar_mein_kul_sewa_kary || "",
//       masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya:
//         formData?.anyaNagar
//           ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya || "",
//     },
//     villagesOver5000: {
//       total_villages: formData?.villagesOver5000?.total_villages || "",
//       business_and_farming_villages:
//         formData?.villagesOver5000?.business_and_farming_villages || "",
//       service_work_villages:
//         formData?.villagesOver5000?.service_work_villages || "",
//       total_service_work: formData?.villagesOver5000?.total_service_work || "",
//       // NEW FIELDS
//       service_settlements_among_them:
//         formData?.villagesOver5000?.service_settlements_among_them || "",
//       branches_meetings_with_service_workers:
//         formData?.villagesOver5000?.branches_meetings_with_service_workers ||
//         "",
//       total_service_workers_in_villages:
//         formData?.villagesOver5000?.total_service_workers_in_villages || "",
//       monthly_service_settlement_contact_branches:
//         formData?.villagesOver5000
//           ?.monthly_service_settlement_contact_branches || "",
//     },
//     villagesUnder5000: {
//       service_work_villages:
//         formData?.villagesUnder5000?.service_work_villages || "",
//       total_service_work: formData?.villagesUnder5000?.total_service_work || "",
//     },
//     form02: {
//       seva_sanskar_1: formData?.form02?.seva_sanskar_1 || "",
//       seva_sanskar_2: formData?.form02?.seva_sanskar_2 || "",
//       august_september: formData?.form02?.august_september || "",
//       branches_visiting_6_plus:
//         formData?.form02?.branches_visiting_6_plus || "",
//       branches_conducting_service_activities:
//         formData?.form02?.branches_conducting_service_activities || "",
//       number_of_service_activities_by_branch:
//         formData?.form02?.number_of_service_activities_by_branch || "",
//       service_initiative_branch:
//         formData?.form02?.service_initiative_branch || "",
//     },
//   };

//   const onSubmit = async (values, { resetForm }) => {
//     try {
//       await dispatch(updateReportingForm({ jila_id: selectedJila, values }));
//       toast.success("Data submitted successfully!");
//       resetForm();
//     } catch (error) {
//       toast.error("Failed to submit. Please try again.");
//     }
//   };

//   const translateName = (name, translationMap) => {
//     if (language.trim() === "hindi" && translationMap[name]) {
//       return translationMap[name];
//     }
//     return name;
//   };

//   const getTooltip = (labelKey) => (
//     <Tooltip id={`tooltip-${labelKey}`}>
//       {fieldLabels[language][`${labelKey}Desc`]}
//     </Tooltip>
//   );

//   return (
//     <>
//       <ToastContainer />
//       <div className="gradient-background">
//         <Container>
//           {/* Centered Bold Heading */}
//           <Row className="justify-content-center mt-3">
//             <Col xs="auto">
//               <h3
//                 style={{
//                   fontWeight: "bold",
//                   border: "2px solid #222",
//                   padding: "8px 32px",
//                   borderRadius: "8px",
//                   background: "#fff",
//                   textAlign: "center",
//                 }}
//               >
//                 {language === "english"
//                   ? fieldLabels[language].form01
//                   : fieldLabels[language].form01}
//               </h3>
//             </Col>
//           </Row>
//           <Row className="mt-3 d-flex justify-content-between align-items-center">
//             <Col xs="auto" className="mt-3 d-flex">
//               {userType === "prant" && (
//                 <Col xs="auto" className="mt-3">
//                   <Form.Control
//                     as="select"
//                     className="form-select"
//                     value={selectedVibhag}
//                     onChange={(e) => {
//                       const selectedId = e.target.value;
//                       setSelectedVibhag(selectedId);
//                       const selectedVibhagData = vibhagList?.map((vibhag) =>
//                         vibhag?.vibhags?.find(
//                           (vibhag) => vibhag._id === selectedId
//                         )
//                       );
//                       setJilaList(() => selectedVibhagData);
//                     }}
//                   >
//                     <option value="" className="bg-dark text-light">
//                       {fieldLabels[language]?.selectVibhag}
//                     </option>
//                     {/* {vibhagList?.map((vibhag) => {
//                       return (

//                         <optgroup  label={vibhag.vibhag_name} key={vibhag.id} >
//                           {vibhag?.vibhags?.map((item) => {
//                             return (
//                               <>
//                                 <option key={item.id} value={item._id}>
//                                   {item.vibhag_name}
//                                 </option>
//                               </>
//                             );
//                           })}
//                         </optgroup>
//                       );
//                     })} */}
//                     {vibhagList?.flatMap((vibhag) =>
//                       vibhag.vibhags?.map((item) => {
//                         const translatedVibhag = translateName(
//                           item.vibhag_name,
//                           VibhagTranslation
//                         );
//                         return (
//                           <option key={item.id} value={item._id}>
//                             {translatedVibhag}
//                           </option>
//                         );
//                       })
//                     )}
//                   </Form.Control>

//                   {selectedVibhag && (
//                     <Form.Control
//                       as="select"
//                       className="form-select mt-3"
//                       value={selectedJila}
//                       onChange={(e) => setSelectedJila(e.target.value)}
//                     >
//                       <option value="" className="bg-dark text-light">
//                         {fieldLabels[language]?.selectJila}
//                       </option>
//                       {jilaList[0].jilas?.map((jila) => {
//                         const translatedJila = translateName(
//                           jila.jila_name,
//                           JilaTranslation
//                         );
//                         return (
//                           <>
//                             <option key={jila._id} value={jila._id}>
//                               {translatedJila}
//                             </option>
//                           </>
//                         );
//                       })}
//                     </Form.Control>
//                   )}
//                 </Col>
//               )}

//               {userType === "vibhag" && (
//                 <Form.Control
//                   as="select"
//                   className="form-select"
//                   onChange={(e) => {
//                     const selectedJilaVal = e.target.value;
//                     setSelectedJila(selectedJilaVal);
//                   }}
//                 >
//                   {vibhagList?.data?.map((jila) => {
//                     return (
//                       <>
//                         <option key={jila.id} value={jila._id}>
//                           {jila.jila_name}
//                         </option>
//                       </>
//                     );
//                   })}

//                   {/* <option value="vibhag2">Indore</option> */}
//                 </Form.Control>
//               )}
//             </Col>
//           </Row>

//           <Formik
//             initialValues={initialValues}
//             enableReinitialize
//             validationSchema={validationSchema}
//             onSubmit={onSubmit}
//           >
//             {({ values, handleChange, handleSubmit, errors, touched }) => (
//               <form onSubmit={handleSubmit}>
//                 {/* Mahanagar Section */}
//                 <Row className="mt-3">
//                   <Col>
//                     <h2>{fieldLabels[language]?.mahanagar}</h2>
//                     <Row>
//                       <Col md={6}>
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.districtNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="mahanagar.zila_sam_mahanagar_bhag_sankhya"
//                             value={
//                               values.mahanagar.zila_sam_mahanagar_bhag_sankhya
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.mahanagar
//                                 ?.zila_sam_mahanagar_bhag_sankhya &&
//                               !!errors.mahanagar
//                                 ?.zila_sam_mahanagar_bhag_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.mahanagar?.zila_sam_mahanagar_bhag_sankhya}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6}>
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.settlementNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="mahanagar.sewa_basti_sankhya"
//                             value={values.mahanagar.sewa_basti_sankhya}
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.mahanagar?.sewa_basti_sankhya &&
//                               !!errors.mahanagar?.sewa_basti_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.mahanagar?.sewa_basti_sankhya}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                     <Row>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.serviceSettlementNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="mahanagar.sewa_kary_yukt_sewa_basti"
//                             value={values.mahanagar.sewa_kary_yukt_sewa_basti}
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.mahanagar?.sewa_kary_yukt_sewa_basti &&
//                               !!errors.mahanagar?.sewa_kary_yukt_sewa_basti
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.mahanagar?.sewa_kary_yukt_sewa_basti}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.businessCollegeNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="mahanagar.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya"
//                             value={
//                               values.mahanagar
//                                 .vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.mahanagar
//                                 ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya &&
//                               !!errors.mahanagar
//                                 ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {
//                               errors.mahanagar
//                                 ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
//                             }
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.settlementBranchNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="mahanagar.sewa_basti_palak_shakha_w_milan_sankhya"
//                             value={
//                               values.mahanagar
//                                 .sewa_basti_palak_shakha_w_milan_sankhya
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.mahanagar
//                                 ?.sewa_basti_palak_shakha_w_milan_sankhya &&
//                               !!errors.mahanagar
//                                 ?.sewa_basti_palak_shakha_w_milan_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {
//                               errors.mahanagar
//                                 ?.sewa_basti_palak_shakha_w_milan_sankhya
//                             }
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.serviceWorkerBranchNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="mahanagar.sewa_karyakarta_yukt_shakha_w_milan_sankhya"
//                             value={
//                               values.mahanagar
//                                 .sewa_karyakarta_yukt_shakha_w_milan_sankhya
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.mahanagar
//                                 ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya &&
//                               !!errors.mahanagar
//                                 ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {
//                               errors.mahanagar
//                                 ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya
//                             }
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.totalServiceWorkers}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="mahanagar.kul_sewa_karyakarta"
//                             value={values.mahanagar.kul_sewa_karyakarta}
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.mahanagar?.kul_sewa_karyakarta &&
//                               !!errors.mahanagar?.kul_sewa_karyakarta
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.mahanagar?.kul_sewa_karyakarta}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.totalServiceWork}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="mahanagar.mahanagar_mein_kul_sewa_kary"
//                             value={
//                               values.mahanagar.mahanagar_mein_kul_sewa_kary
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.mahanagar?.mahanagar_mein_kul_sewa_kary &&
//                               !!errors.mahanagar?.mahanagar_mein_kul_sewa_kary
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.mahanagar?.mahanagar_mein_kul_sewa_kary}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.monthlyContactNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="mahanagar.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya"
//                             value={
//                               values.mahanagar
//                                 .masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.mahanagar
//                                 ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya &&
//                               !!errors.mahanagar
//                                 ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {
//                               errors.mahanagar
//                                 ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
//                             }
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       {/* New Field: Total Number of Metropolitan Cities */}
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.totalMetropolitanCities}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="mahanagar.total_metropolitan_cities"
//                             value={values.mahanagar.total_metropolitan_cities}
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.mahanagar?.total_metropolitan_cities &&
//                               !!errors.mahanagar?.total_metropolitan_cities
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.mahanagar?.total_metropolitan_cities}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       {/* New Field: Number of Metropolitan Cities with Functional Services */}
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {
//                               fieldLabels[language]
//                                 ?.functionalMetropolitanCities
//                             }
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="mahanagar.functional_metropolitan_cities"
//                             value={
//                               values.mahanagar.functional_metropolitan_cities
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.mahanagar
//                                 ?.functional_metropolitan_cities &&
//                               !!errors.mahanagar?.functional_metropolitan_cities
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.mahanagar?.functional_metropolitan_cities}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                   </Col>
//                 </Row>

//                 {/* Jila Kendra Section */}
//                 <Row className="mt-3">
//                   <Col>
//                     <h2>{fieldLabels[language]?.jilaKendra}</h2>
//                     <Row>
//                       <Col md={6}>
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.districtNumberJilaKendra}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="jilaKendra.zila_sam_mahanagar_bhag_sankhya"
//                             value={
//                               values.jilaKendra.zila_sam_mahanagar_bhag_sankhya
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.jilaKendra
//                                 ?.zila_sam_mahanagar_bhag_sankhya &&
//                               !!errors.jilaKendra
//                                 ?.zila_sam_mahanagar_bhag_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.jilaKendra?.zila_sam_mahanagar_bhag_sankhya}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6}>
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.settlementNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="jilaKendra.sewa_basti_sankhya"
//                             value={values.jilaKendra.sewa_basti_sankhya}
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.jilaKendra?.sewa_basti_sankhya &&
//                               !!errors.jilaKendra?.sewa_basti_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.jilaKendra?.sewa_basti_sankhya}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                     <Row>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.serviceSettlementNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="jilaKendra.sewa_kary_yukt_sewa_basti"
//                             value={values.jilaKendra.sewa_kary_yukt_sewa_basti}
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.jilaKendra?.sewa_kary_yukt_sewa_basti &&
//                               !!errors.jilaKendra?.sewa_kary_yukt_sewa_basti
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.jilaKendra?.sewa_kary_yukt_sewa_basti}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.businessCollegeNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="jilaKendra.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya"
//                             value={
//                               values.jilaKendra
//                                 .vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.jilaKendra
//                                 ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya &&
//                               !!errors.jilaKendra
//                                 ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {
//                               errors.jilaKendra
//                                 ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
//                             }
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.settlementBranchNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="jilaKendra.sewa_basti_palak_shakha_w_milan_sankhya"
//                             value={
//                               values.jilaKendra
//                                 .sewa_basti_palak_shakha_w_milan_sankhya
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.jilaKendra
//                                 ?.sewa_basti_palak_shakha_w_milan_sankhya &&
//                               !!errors.jilaKendra
//                                 ?.sewa_basti_palak_shakha_w_milan_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {
//                               errors.jilaKendra
//                                 ?.sewa_basti_palak_shakha_w_milan_sankhya
//                             }
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.serviceWorkerBranchNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="jilaKendra.sewa_karyakarta_yukt_shakha_w_milan_sankhya"
//                             value={
//                               values.jilaKendra
//                                 .sewa_karyakarta_yukt_shakha_w_milan_sankhya
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.jilaKendra
//                                 ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya &&
//                               !!errors.jilaKendra
//                                 ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {
//                               errors.jilaKendra
//                                 ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya
//                             }
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.totalServiceWorkers}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="jilaKendra.kul_sewa_karyakarta"
//                             value={values.jilaKendra.kul_sewa_karyakarta}
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.jilaKendra?.kul_sewa_karyakarta &&
//                               !!errors.jilaKendra?.kul_sewa_karyakarta
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.jilaKendra?.kul_sewa_karyakarta}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.totalServiceWorkJilaKendra}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="jilaKendra.mahanagar_mein_kul_sewa_kary"
//                             value={
//                               values.jilaKendra.mahanagar_mein_kul_sewa_kary
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.jilaKendra
//                                 ?.mahanagar_mein_kul_sewa_kary &&
//                               !!errors.jilaKendra?.mahanagar_mein_kul_sewa_kary
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.jilaKendra?.mahanagar_mein_kul_sewa_kary}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.monthlyContactNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="jilaKendra.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya"
//                             value={
//                               values.jilaKendra
//                                 .masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.jilaKendra
//                                 ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya &&
//                               !!errors.jilaKendra
//                                 ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {
//                               errors.jilaKendra
//                                 ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
//                             }
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       {/* New Field: Total Number of Blocks */}
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.totalBlocks}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="jilaKendra.total_blocks"
//                             value={values.jilaKendra.total_blocks}
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.jilaKendra?.total_blocks &&
//                               !!errors.jilaKendra?.total_blocks
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.jilaKendra?.total_blocks}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       {/* New Field: Number of Blocks with Services */}
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.blocksWithServices}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="jilaKendra.blocks_with_services"
//                             value={values.jilaKendra.blocks_with_services}
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.jilaKendra?.blocks_with_services &&
//                               !!errors.jilaKendra?.blocks_with_services
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.jilaKendra?.blocks_with_services}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                   </Col>
//                 </Row>

//                 {/* Anya Nagar Section */}
//                 <Row className="mt-3">
//                   <Col>
//                     <h2>{fieldLabels[language]?.anyaNagar}</h2>
//                     <Row>
//                       <Col md={6}>
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.districtNumberAnyaNagar}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="anyaNagar.zila_sam_mahanagar_bhag_sankhya"
//                             value={
//                               values.anyaNagar.zila_sam_mahanagar_bhag_sankhya
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.anyaNagar
//                                 ?.zila_sam_mahanagar_bhag_sankhya &&
//                               !!errors.anyaNagar
//                                 ?.zila_sam_mahanagar_bhag_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.anyaNagar?.zila_sam_mahanagar_bhag_sankhya}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6}>
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.settlementNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="anyaNagar.sewa_basti_sankhya"
//                             value={values.anyaNagar.sewa_basti_sankhya}
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.anyaNagar?.sewa_basti_sankhya &&
//                               !!errors.anyaNagar?.sewa_basti_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.anyaNagar?.sewa_basti_sankhya}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                     <Row>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.serviceSettlementNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="anyaNagar.sewa_kary_yukt_sewa_basti"
//                             value={values.anyaNagar.sewa_kary_yukt_sewa_basti}
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.mahanagar
//                                 ?.zila_sam_mahanagar_bhag_sankhya &&
//                               !!errors.mahanagar
//                                 ?.zila_sam_mahanagar_bhag_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.anyaNagar?.sewa_kary_yukt_sewa_basti}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.businessCollegeNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="anyaNagar.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya"
//                             value={
//                               values.anyaNagar
//                                 .vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.anyaNagar
//                                 ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya &&
//                               !!errors.anyaNagar
//                                 ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {
//                               errors.anyaNagar
//                                 ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
//                             }
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.settlementBranchNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="anyaNagar.sewa_basti_palak_shakha_w_milan_sankhya"
//                             value={
//                               values.anyaNagar
//                                 .sewa_basti_palak_shakha_w_milan_sankhya
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.anyaNagar
//                                 ?.sewa_basti_palak_shakha_w_milan_sankhya &&
//                               !!errors.anyaNagar
//                                 ?.sewa_basti_palak_shakha_w_milan_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {
//                               errors.anyaNagar
//                                 ?.sewa_basti_palak_shakha_w_milan_sankhya
//                             }
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.serviceWorkerBranchNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="anyaNagar.sewa_karyakarta_yukt_shakha_w_milan_sankhya"
//                             value={
//                               values.anyaNagar
//                                 .sewa_karyakarta_yukt_shakha_w_milan_sankhya
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.anyaNagar
//                                 ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya &&
//                               !!errors.anyaNagar
//                                 ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {
//                               errors.anyaNagar
//                                 ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya
//                             }
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.totalServiceWorkers}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="anyaNagar.kul_sewa_karyakarta"
//                             value={values.anyaNagar.kul_sewa_karyakarta}
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.anyaNagar?.kul_sewa_karyakarta &&
//                               !!errors.anyaNagar?.kul_sewa_karyakarta
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.anyaNagar?.kul_sewa_karyakarta}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.totalServiceWorkAnyaNagar}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="anyaNagar.mahanagar_mein_kul_sewa_kary"
//                             value={
//                               values.anyaNagar.mahanagar_mein_kul_sewa_kary
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.anyaNagar?.mahanagar_mein_kul_sewa_kary &&
//                               !!errors.anyaNagar?.mahanagar_mein_kul_sewa_kary
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.anyaNagar?.mahanagar_mein_kul_sewa_kary}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.monthlyContactNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="anyaNagar.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya"
//                             value={
//                               values.anyaNagar
//                                 .masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.anyaNagar
//                                 ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya &&
//                               !!errors.anyaNagar
//                                 ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {
//                               errors.anyaNagar
//                                 ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
//                             }
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                   </Col>
//                 </Row>

//                 {/* Villages Section above 5000*/}
//                 <Row className="mt-3">
//                   <Col>
//                     <h2>{fieldLabels[language]?.villagesOver5000}</h2>
//                     <Row>
//                       <Col md={6}>
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.villagesOver5000}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="villagesOver5000.total_villages"
//                             value={values.villagesOver5000.total_villages}
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.villagesOver5000?.total_villages &&
//                               !!errors.villagesOver5000?.total_villages
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.villagesOver5000?.total_villages}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>

//                       <Col md={6}>
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.businessVillageNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="villagesOver5000.business_and_farming_villages"
//                             value={
//                               values.villagesOver5000
//                                 .business_and_farming_villages
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.villagesOver5000
//                                 ?.business_and_farming_villages &&
//                               !!errors.villagesOver5000
//                                 ?.business_and_farming_villages
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {
//                               errors.villagesOver5000
//                                 ?.business_and_farming_villages
//                             }
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>

//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.serviceVillageNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="villagesOver5000.service_work_villages"
//                             value={
//                               values.villagesOver5000.service_work_villages
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.villagesOver5000?.service_work_villages &&
//                               !!errors.villagesOver5000?.service_work_villages
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.villagesOver5000?.service_work_villages}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>

//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.totalServiceInVillages}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="villagesOver5000.total_service_work"
//                             value={values.villagesOver5000.total_service_work}
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.villagesOver5000?.total_service_work &&
//                               !!errors.villagesOver5000?.total_service_work
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.villagesOver5000?.total_service_work}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       {/* New Field: Number of Service Settlements among them (if specified) */}
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.serviceSettlementsAmongThem}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="villagesOver5000.service_settlements_among_them"
//                             value={
//                               values.villagesOver5000
//                                 .service_settlements_among_them
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.villagesOver5000
//                                 ?.service_settlements_among_them &&
//                               !!errors.villagesOver5000
//                                 ?.service_settlements_among_them
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {
//                               errors.villagesOver5000
//                                 ?.service_settlements_among_them
//                             }
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       {/* New Field: Number of Branches and Meetings with Service Workers */}
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {
//                               fieldLabels[language]
//                                 ?.branchesMeetingsWithServiceWorkers
//                             }
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="villagesOver5000.branches_meetings_with_service_workers"
//                             value={
//                               values.villagesOver5000
//                                 .branches_meetings_with_service_workers
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.villagesOver5000
//                                 ?.branches_meetings_with_service_workers &&
//                               !!errors.villagesOver5000
//                                 ?.branches_meetings_with_service_workers
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {
//                               errors.villagesOver5000
//                                 ?.branches_meetings_with_service_workers
//                             }
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       {/* New Field: Total Number of Service Workers */}
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {
//                               fieldLabels[language]
//                                 ?.totalServiceWorkersInVillages
//                             }
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="villagesOver5000.total_service_workers_in_villages"
//                             value={
//                               values.villagesOver5000
//                                 .total_service_workers_in_villages
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.villagesOver5000
//                                 ?.total_service_workers_in_villages &&
//                               !!errors.villagesOver5000
//                                 ?.total_service_workers_in_villages
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {
//                               errors.villagesOver5000
//                                 ?.total_service_workers_in_villages
//                             }
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                       {/* New Field: Branch Conducting Monthly Service Settlement Contact */}
//                       <Col md={6} className="mt-2">
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.monthlyContactNumber}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="villagesOver5000.monthly_service_settlement_contact_branches"
//                             value={
//                               values.villagesOver5000
//                                 .monthly_service_settlement_contact_branches
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.villagesOver5000
//                                 ?.monthly_service_settlement_contact_branches &&
//                               !!errors.villagesOver5000
//                                 ?.monthly_service_settlement_contact_branches
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {
//                               errors.villagesOver5000
//                                 ?.monthly_service_settlement_contact_branches
//                             }
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                   </Col>
//                 </Row>

//                 {/* Villages Section below 5000*/}
//                 <Row className="mt-3">
//                   <Col>
//                     <h2>{fieldLabels[language]?.villagesUnder5000}</h2>
//                     <Row>
//                       <Col md={6}>
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.villagesUnderess5000}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="villagesUnder5000.service_work_villages"
//                             value={
//                               values.villagesUnder5000.service_work_villages
//                             }
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.villagesUnder5000
//                                 ?.service_work_villages &&
//                               !!errors.villagesUnder5000?.service_work_villages
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.villagesUnder5000?.service_work_villages}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>

//                       <Col md={6}>
//                         <Form.Group>
//                           <Form.Label>
//                             {fieldLabels[language]?.totalServiceInVillages}
//                           </Form.Label>
//                           <Form.Control
//                             type="number"
//                             placeholder="Enter number"
//                             name="villagesUnder5000.total_service_work"
//                             value={values.villagesUnder5000.total_service_work}
//                             onChange={handleChange}
//                             isInvalid={
//                               touched.villagesUnder5000?.total_service_work &&
//                               !!errors.villagesUnder5000?.total_service_work
//                             }
//                             disabled={
//                               userType === "kshetra" || userType === "kendra"
//                             }
//                           />
//                           <Form.Control.Feedback type="invalid">
//                             {errors.villagesUnder5000?.total_service_work}
//                           </Form.Control.Feedback>
//                         </Form.Group>
//                       </Col>
//                     </Row>
//                   </Col>
//                 </Row>

//                 {/* Centered Text for Form 02 */}
//                 <h2 className="Prapatra">
//                   {fieldLabels[language].sevaShikshanWorkReport}
//                 </h2>

//                 {/* Form 02 as input fields (not table) */}
//                 <Row className="mt-4">
//                   <Col md={6}>
//                     <Form.Group>
//                       <Form.Label>
//                         {fieldLabels[language].sevaSanskar1}
//                       </Form.Label>
//                       <Form.Control
//                         type="number"
//                         placeholder="Enter number"
//                         name="form02.seva_sanskar_1"
//                         value={values.form02.seva_sanskar_1}
//                         onChange={handleChange}
//                         isInvalid={
//                           touched.form02?.seva_sanskar_1 &&
//                           !!errors.form02?.seva_sanskar_1
//                         }
//                         disabled={
//                           userType === "kshetra" || userType === "kendra"
//                         }
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.form02?.seva_sanskar_1}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group>
//                       <Form.Label>
//                         {fieldLabels[language].sevaSanskar2}
//                       </Form.Label>
//                       <Form.Control
//                         type="number"
//                         placeholder="Enter number"
//                         name="form02.seva_sanskar_2"
//                         value={values.form02.seva_sanskar_2}
//                         onChange={handleChange}
//                         isInvalid={
//                           touched.form02?.seva_sanskar_2 &&
//                           !!errors.form02?.seva_sanskar_2
//                         }
//                         disabled={
//                           userType === "kshetra" || userType === "kendra"
//                         }
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.form02?.seva_sanskar_2}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 <Row className="mt-2">
//                   <Col md={6}>
//                     <Form.Group>
//                       <Form.Label>
//                         {fieldLabels[language].augustSeptember}
//                       </Form.Label>
//                       <Form.Control
//                         type="number"
//                         placeholder="Enter number"
//                         name="form02.august_september"
//                         value={values.form02.august_september}
//                         onChange={handleChange}
//                         isInvalid={
//                           touched.form02?.august_september &&
//                           !!errors.form02?.august_september
//                         }
//                         disabled={
//                           userType === "kshetra" || userType === "kendra"
//                         }
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.form02?.august_september}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group>
//                       <Form.Label>
//                         {fieldLabels[language].branchesVisiting6Plus}
//                       </Form.Label>
//                       <Form.Control
//                         type="number"
//                         placeholder="Enter number"
//                         name="form02.branches_visiting_6_plus"
//                         value={values.form02.branches_visiting_6_plus}
//                         onChange={handleChange}
//                         isInvalid={
//                           touched.form02?.branches_visiting_6_plus &&
//                           !!errors.form02?.branches_visiting_6_plus
//                         }
//                         disabled={
//                           userType === "kshetra" || userType === "kendra"
//                         }
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.form02?.branches_visiting_6_plus}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 <Row className="mt-2">
//                   <Col md={6}>
//                     <Form.Group>
//                       <Form.Label>
//                         {
//                           fieldLabels[language]
//                             .branchesConductingServiceActivities
//                         }
//                       </Form.Label>
//                       <Form.Control
//                         type="number"
//                         placeholder="Enter number"
//                         name="form02.branches_conducting_service_activities"
//                         value={
//                           values.form02.branches_conducting_service_activities
//                         }
//                         onChange={handleChange}
//                         isInvalid={
//                           touched.form02
//                             ?.branches_conducting_service_activities &&
//                           !!errors.form02
//                             ?.branches_conducting_service_activities
//                         }
//                         disabled={
//                           userType === "kshetra" || userType === "kendra"
//                         }
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.form02?.branches_conducting_service_activities}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                   <Col md={6}>
//                     <Form.Group>
//                       <Form.Label>
//                         {
//                           fieldLabels[language]
//                             .numberOfServiceActivitiesConducted
//                         }
//                       </Form.Label>
//                       <Form.Control
//                         type="number"
//                         placeholder="Enter number"
//                         name="form02.number_of_service_activities_by_branch"
//                         value={
//                           values.form02.number_of_service_activities_by_branch
//                         }
//                         onChange={handleChange}
//                         isInvalid={
//                           touched.form02
//                             ?.number_of_service_activities_by_branch &&
//                           !!errors.form02
//                             ?.number_of_service_activities_by_branch
//                         }
//                         disabled={
//                           userType === "kshetra" || userType === "kendra"
//                         }
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.form02?.number_of_service_activities_by_branch}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                 </Row>
//                 <Row className="mt-2">
//                   <Col md={6}>
//                     <Form.Group>
//                       <Form.Label>
//                         {fieldLabels[language].serviceInitiativeBranch}
//                       </Form.Label>
//                       <Form.Control
//                         type="number"
//                         placeholder="Enter number"
//                         name="form02.service_initiative_branch"
//                         value={values.form02.service_initiative_branch}
//                         onChange={handleChange}
//                         isInvalid={
//                           touched.form02?.service_initiative_branch &&
//                           !!errors.form02?.service_initiative_branch
//                         }
//                         disabled={
//                           userType === "kshetra" || userType === "kendra"
//                         }
//                       />
//                       <Form.Control.Feedback type="invalid">
//                         {errors.form02?.service_initiative_branch}
//                       </Form.Control.Feedback>
//                     </Form.Group>
//                   </Col>
//                 </Row>

//                 {/* Final Submit Button at bottom */}
//                 <Row className="mt-4">
//                   <Col className="text-center">
//                     <Button
//                       type="submit"
//                       className="submit_buttons"
//                       disabled={userType === "kshetra" || userType === "kendra"}
//                     >
//                       {userType === "vibhag" || userType === "prant"
//                         ? `${fieldLabels[language]?.SaveAsSubmit}`
//                         : `${fieldLabels[language]?.Submit}`}
//                     </Button>
//                   </Col>
//                 </Row>
//               </form>
//             )}
//           </Formik>
//         </Container>
//       </div>
//     </>
//   );
// };

// export default Jilareport;

import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import "./Jilareport.css";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import fieldLabels from "./FiledLabels";
import {
  fetchVibhagList,
  fetchFormDataByJila,
  updateReportingForm,
  clearFormData,
  createReportingForm,
} from "../redux/slice/JilaReportSlice";
import { JilaTranslation, VibhagTranslation } from "./Fileds";

const Jilareport = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const language = useSelector((state) => state.language.language);
  const vibhagList = useSelector((state) => state.jilareport.vibhagList);
  const formData = useSelector((state) => state.jilareport.formData);
  const userType = user?.user_type || "Guest";
  const [selectedVibhag, setSelectedVibhag] = useState("");
  const [selectedJila, setSelectedJila] = useState("");
  const [jilaList, setJilaList] = useState();

  useEffect(() => {
    if (userType === "prant" || userType === "vibhag") {
      dispatch(fetchVibhagList());
    }
  }, [dispatch, userType]);

  useEffect(() => {
    dispatch(clearFormData());
    if (selectedJila) {
      dispatch(fetchFormDataByJila(selectedJila));
    } else {
      dispatch(clearFormData());
    }
  }, [dispatch, selectedJila]);

  useEffect(() => {
    setSelectedJila("");
    dispatch(clearFormData());
  }, [dispatch, selectedVibhag]);

  const validationSchema = Yup.object({
    mahanagar: Yup.object({
      zila_sam_mahanagar_bhag_sankhya: Yup.number().required(
        "This field is required"
      ),
      sewa_basti_sankhya: Yup.number().required("This field is required"),
      sewa_kary_yukt_sewa_basti: Yup.number().required(
        "This field is required"
      ),
      vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya: Yup.number().required(
        "This field is required"
      ),
      sewa_basti_palak_shakha_w_milan_sankhya: Yup.number().required(
        "This field is required"
      ),
      sewa_karyakarta_yukt_shakha_w_milan_sankhya: Yup.number().required(
        "This field is required"
      ),
      kul_sewa_karyakarta: Yup.number().required("This field is required"),
      mahanagar_mein_kul_sewa_kary: Yup.number().required(
        "This field is required"
      ),
      masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya:
        Yup.number().required("This field is required"),
      kul_mahanagariy_nagar_sankhya: Yup.number().required(
        "This field is required"
      ),
      seva_karyayukt_mahanagariy_nagar_sankhya: Yup.number().required(
        "This field is required"
      ),
    }),
    jilaKendra: Yup.object({
      zila_sam_jila_kendra_bhag_sankhya: Yup.number().required(
        "This field is required"
      ),
      inmein_sewa_basti_sankhya: Yup.number().required(
        "This field is required"
      ),
      sewa_kary_yukt_sewa_basti: Yup.number().required(
        "This field is required"
      ),
      vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya: Yup.number().required(
        "This field is required"
      ),
      sewa_basti_palak_shakha_w_milan_sankhya: Yup.number().required(
        "This field is required"
      ),
      sewa_karyakarta_yukt_shakha_w_milan_sankhya: Yup.number().required(
        "This field is required"
      ),
      kul_sewa_karyakarta: Yup.number().required("This field is required"),
      jila_kendra_mein_kul_sewa_kary: Yup.number().required(
        "This field is required"
      ),
      masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya:
        Yup.number().required("This field is required"),
      kul_khand: Yup.number().required("This field is required"),
      seva_yukt_khand: Yup.number().required("This field is required"),
    }),
    anyaNagar: Yup.object({
      zila_sam_anya_nagar_bhag_sankhya: Yup.number().required(
        "This field is required"
      ),
      inmein_sewa_basti_sankhya: Yup.number().required(
        "This field is required"
      ),
      sewa_kary_yukt_sewa_basti: Yup.number().required(
        "This field is required"
      ),
      vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya: Yup.number().required(
        "This field is required"
      ),
      sewa_basti_palak_shakha_w_milan_sankhya: Yup.number().required(
        "This field is required"
      ),
      sewa_karyakarta_yukt_shakha_w_milan_sankhya: Yup.number().required(
        "This field is required"
      ),
      kul_sewa_karyakarta: Yup.number().required("This field is required"),
      anya_nagar_mein_kul_sewa_kary: Yup.number().required(
        "This field is required"
      ),
      masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya:
        Yup.number().required("This field is required"),
    }),
    villagesOver5000: Yup.object({
      total_villages: Yup.number().required("This field is required"),
      inmein_seva_basti_ki_sankhya: Yup.number().required(
        "This field is required"
      ),
      business_and_farming_villages: Yup.number().required(
        "This field is required"
      ),
      service_work_villages: Yup.number().required("This field is required"),
      seva_karyakarta_yukt_shakha_va_milan_sankhya: Yup.number().required(
        "This field is required"
      ),
      kul_seva_karyakarta: Yup.number().required("This field is required"),
      total_service_work: Yup.number().required("This field is required"),
      masik_seva_basti_sampark_karne_wali_shakha: Yup.number().required(
        "This field is required"
      ),
    }),
    villagesUnder5000: Yup.object({
      service_work_villages: Yup.number().required("This field is required"),
      total_service_work: Yup.number().required("This field is required"),
    }),
    sevaShikshanKaryaVritt: Yup.object({
      seva_sanskar_1: Yup.number().required("This field is required"),
      seva_sanskar_2: Yup.number().required("This field is required"),
      august_september: Yup.number().required("This field is required"),
      branches_visiting_6_plus: Yup.number().required("This field is required"),
      branches_conducting_service_activities: Yup.number().required(
        "This field is required"
      ),
      number_of_service_activities_by_branch: Yup.number().required(
        "This field is required"
      ),
      service_initiative_branch: Yup.number().required(
        "This field is required"
      ),
    }),
  });

  const initialValues = {
    mahanagar: {
      zila_sam_mahanagar_bhag_sankhya:
        formData?.mahanagar?.zila_sam_mahanagar_bhag_sankhya || "",
      sewa_basti_sankhya: formData?.mahanagar?.sewa_basti_sankhya || "",
      sewa_kary_yukt_sewa_basti:
        formData?.mahanagar?.sewa_kary_yukt_sewa_basti || "",
      vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya:
        formData?.mahanagar?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya ||
        "",
      sewa_basti_palak_shakha_w_milan_sankhya:
        formData?.mahanagar?.sewa_basti_palak_shakha_w_milan_sankhya || "",
      sewa_karyakarta_yukt_shakha_w_milan_sankhya:
        formData?.mahanagar?.sewa_karyakarta_yukt_shakha_w_milan_sankhya || "",
      kul_sewa_karyakarta: formData?.mahanagar?.kul_sewa_karyakarta || "",
      mahanagar_mein_kul_sewa_kary:
        formData?.mahanagar?.mahanagar_mein_kul_sewa_kary || "",
      masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya:
        formData?.mahanagar
          ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya || "",
      kul_mahanagariy_nagar_sankhya:
        formData?.mahanagar?.kul_mahanagariy_nagar_sankhya || "",
      seva_karyayukt_mahanagariy_nagar_sankhya:
        formData?.mahanagar?.seva_karyayukt_mahanagariy_nagar_sankhya || "",
    },
    jilaKendra: {
      zila_sam_jila_kendra_bhag_sankhya:
        formData?.jilaKendra?.zila_sam_jila_kendra_bhag_sankhya || "",
      inmein_sewa_basti_sankhya:
        formData?.jilaKendra?.inmein_sewa_basti_sankhya || "",
      sewa_kary_yukt_sewa_basti:
        formData?.jilaKendra?.sewa_kary_yukt_sewa_basti || "",
      vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya:
        formData?.jilaKendra?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya ||
        "",
      sewa_basti_palak_shakha_w_milan_sankhya:
        formData?.jilaKendra?.sewa_basti_palak_shakha_w_milan_sankhya || "",
      sewa_karyakarta_yukt_shakha_w_milan_sankhya:
        formData?.jilaKendra?.sewa_karyakarta_yukt_shakha_w_milan_sankhya || "",
      kul_sewa_karyakarta: formData?.jilaKendra?.kul_sewa_karyakarta || "",
      jila_kendra_mein_kul_sewa_kary:
        formData?.jilaKendra?.jila_kendra_mein_kul_sewa_kary || "",
      masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya:
        formData?.jilaKendra
          ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya || "",
      kul_khand: formData?.jilaKendra?.kul_khand || "",
      seva_yukt_khand: formData?.jilaKendra?.seva_yukt_khand || "",
    },
    anyaNagar: {
      zila_sam_anya_nagar_bhag_sankhya:
        formData?.anyaNagar?.zila_sam_anya_nagar_bhag_sankhya || "",
      inmein_sewa_basti_sankhya:
        formData?.anyaNagar?.inmein_sewa_basti_sankhya || "",
      sewa_kary_yukt_sewa_basti:
        formData?.anyaNagar?.sewa_kary_yukt_sewa_basti || "",
      vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya:
        formData?.anyaNagar?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya ||
        "",
      sewa_basti_palak_shakha_w_milan_sankhya:
        formData?.anyaNagar?.sewa_basti_palak_shakha_w_milan_sankhya || "",
      sewa_karyakarta_yukt_shakha_w_milan_sankhya:
        formData?.anyaNagar?.sewa_karyakarta_yukt_shakha_w_milan_sankhya || "",
      kul_sewa_karyakarta: formData?.anyaNagar?.kul_sewa_karyakarta || "",
      anya_nagar_mein_kul_sewa_kary:
        formData?.anyaNagar?.anya_nagar_mein_kul_sewa_kary || "",
      masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya:
        formData?.anyaNagar
          ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya || "",
    },
    villagesOver5000: {
      total_villages: formData?.villagesOver5000?.total_villages || "",
      inmein_seva_basti_ki_sankhya:
        formData?.villagesOver5000?.inmein_seva_basti_ki_sankhya || "",
      business_and_farming_villages:
        formData?.villagesOver5000?.business_and_farming_villages || "",
      service_work_villages:
        formData?.villagesOver5000?.service_work_villages || "",
      seva_karyakarta_yukt_shakha_va_milan_sankhya:
        formData?.villagesOver5000
          ?.seva_karyakarta_yukt_shakha_va_milan_sankhya || "",
      kul_seva_karyakarta:
        formData?.villagesOver5000?.kul_seva_karyakarta || "",
      total_service_work: formData?.villagesOver5000?.total_service_work || "",
      masik_seva_basti_sampark_karne_wali_shakha:
        formData?.villagesOver5000
          ?.masik_seva_basti_sampark_karne_wali_shakha || "",
    },
    villagesUnder5000: {
      service_work_villages:
        formData?.villagesUnder5000?.service_work_villages || "",
      total_service_work: formData?.villagesUnder5000?.total_service_work || "",
    },
    sevaShikshanKaryaVritt: {
      seva_sanskar_1:
        formData?.sevaShikshanKaryaVritt?.seva_sanskar_1 ||
        formData?.form02?.seva_sanskar_1 ||
        "",
      seva_sanskar_2:
        formData?.sevaShikshanKaryaVritt?.seva_sanskar_2 ||
        formData?.form02?.seva_sanskar_2 ||
        "",
      august_september:
        formData?.sevaShikshanKaryaVritt?.august_september ||
        formData?.form02?.august_september ||
        "",
      branches_visiting_6_plus:
        formData?.sevaShikshanKaryaVritt?.branches_visiting_6_plus ||
        formData?.form02?.branches_visiting_6_plus ||
        "",
      branches_conducting_service_activities:
        formData?.sevaShikshanKaryaVritt
          ?.branches_conducting_service_activities ||
        formData?.form02?.branches_conducting_service_activities ||
        "",
      number_of_service_activities_by_branch:
        formData?.sevaShikshanKaryaVritt
          ?.number_of_service_activities_by_branch ||
        formData?.form02?.number_of_service_activities_by_branch ||
        "",
      service_initiative_branch:
        formData?.sevaShikshanKaryaVritt?.service_initiative_branch ||
        formData?.form02?.service_initiative_branch ||
        "",
    },
  };

  const isEditMode = formData !== null;

  const onSubmit = async (values, { resetForm }) => {
    try {
      const payload = {
        ...values,
      };
      let result;
      if (isEditMode) {
        result = await dispatch(
          updateReportingForm({ jila_id: selectedJila, values: payload })
        ).unwrap();
      } else {
        result = await dispatch(createReportingForm(payload)).unwrap();
      }
      toast.success("Data submitted successfully!");
      resetForm();
    } catch (error) {
      const errorMessage =
        error.message || "Failed to submit. Please try again.";
      toast.error(errorMessage);
    }
  };

  const translateName = (name, translationMap) => {
    if (language.trim() === "hindi" && translationMap[name]) {
      return translationMap[name];
    }
    return name;
  };

  return (
    <>
      <ToastContainer />
      <div className="gradient-background">
        <Container>
          <Row className="mt-3 d-flex justify-content-between align-items-center">
            <Col xs="auto" className="mt-3 d-flex">
              {userType === "prant" && (
                <Col xs="auto" className="mt-3">
                  <Form.Control
                    as="select"
                    className="form-select"
                    value={selectedVibhag}
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      setSelectedVibhag(selectedId);
                      const selectedVibhagData = vibhagList?.map((vibhag) =>
                        vibhag?.vibhags?.find(
                          (vibhag) => vibhag._id === selectedId
                        )
                      );
                      setJilaList(() => selectedVibhagData);
                    }}
                  >
                    <option value="" className="bg-dark text-light">
                      {fieldLabels[language]?.selectVibhag}
                    </option>
                    {vibhagList?.flatMap((vibhag) =>
                      vibhag.vibhags?.map((item) => {
                        const translatedVibhag = translateName(
                          item.vibhag_name,
                          VibhagTranslation
                        );
                        return (
                          <option key={item.id} value={item._id}>
                            {translatedVibhag}
                          </option>
                        );
                      })
                    )}
                  </Form.Control>
                  {selectedVibhag && (
                    <Form.Control
                      as="select"
                      className="form-select mt-3"
                      value={selectedJila}
                      onChange={(e) => setSelectedJila(e.target.value)}
                    >
                      <option value="" className="bg-dark text-light">
                        {fieldLabels[language]?.selectJila}
                      </option>
                      {jilaList[0].jilas?.map((jila) => {
                        const translatedJila = translateName(
                          jila.jila_name,
                          JilaTranslation
                        );
                        return (
                          <option key={jila._id} value={jila._id}>
                            {translatedJila}
                          </option>
                        );
                      })}
                    </Form.Control>
                  )}
                </Col>
              )}
              {userType === "vibhag" && (
                <Form.Control
                  as="select"
                  className="form-select"
                  onChange={(e) => {
                    const selectedJilaVal = e.target.value;
                    setSelectedJila(selectedJilaVal);
                  }}
                >
                  <option value="" className="bg-dark text-light">
                    {fieldLabels[language]?.selectJila}
                  </option>
                  {vibhagList?.data?.map((jila) => {
                    return (
                      <option key={jila._id} value={jila._id}>
                        {jila.jila_name}
                      </option>
                    );
                  })}
                </Form.Control>
              )}
            </Col>
          </Row>
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ values, handleChange, handleSubmit, errors, touched }) => (
              <form onSubmit={handleSubmit}>
                {/* Mahanagar Section */}
                <Row className="mt-3">
                  <Col>
                    <h2>{fieldLabels[language]?.mahanagar}</h2>
                    <Row>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.districtNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="mahanagar.zila_sam_mahanagar_bhag_sankhya"
                            value={
                              values.mahanagar.zila_sam_mahanagar_bhag_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.mahanagar
                                ?.zila_sam_mahanagar_bhag_sankhya &&
                              !!errors.mahanagar
                                ?.zila_sam_mahanagar_bhag_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.mahanagar?.zila_sam_mahanagar_bhag_sankhya}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.settlementNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="mahanagar.sewa_basti_sankhya"
                            value={values.mahanagar.sewa_basti_sankhya}
                            onChange={handleChange}
                            isInvalid={
                              touched.mahanagar?.sewa_basti_sankhya &&
                              !!errors.mahanagar?.sewa_basti_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.mahanagar?.sewa_basti_sankhya}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.serviceSettlementNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="mahanagar.sewa_kary_yukt_sewa_basti"
                            value={values.mahanagar.sewa_kary_yukt_sewa_basti}
                            onChange={handleChange}
                            isInvalid={
                              touched.mahanagar?.sewa_kary_yukt_sewa_basti &&
                              !!errors.mahanagar?.sewa_kary_yukt_sewa_basti
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.mahanagar?.sewa_kary_yukt_sewa_basti}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.businessCollegeNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="mahanagar.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya"
                            value={
                              values.mahanagar
                                .vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.mahanagar
                                ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya &&
                              !!errors.mahanagar
                                ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.mahanagar
                                ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.settlementBranchNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="mahanagar.sewa_basti_palak_shakha_w_milan_sankhya"
                            value={
                              values.mahanagar
                                .sewa_basti_palak_shakha_w_milan_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.mahanagar
                                ?.sewa_basti_palak_shakha_w_milan_sankhya &&
                              !!errors.mahanagar
                                ?.sewa_basti_palak_shakha_w_milan_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.mahanagar
                                ?.sewa_basti_palak_shakha_w_milan_sankhya
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.serviceWorkerBranchNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="mahanagar.sewa_karyakarta_yukt_shakha_w_milan_sankhya"
                            value={
                              values.mahanagar
                                .sewa_karyakarta_yukt_shakha_w_milan_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.mahanagar
                                ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya &&
                              !!errors.mahanagar
                                ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.mahanagar
                                ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.totalServiceWorkers}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="mahanagar.kul_sewa_karyakarta"
                            value={values.mahanagar.kul_sewa_karyakarta}
                            onChange={handleChange}
                            isInvalid={
                              touched.mahanagar?.kul_sewa_karyakarta &&
                              !!errors.mahanagar?.kul_sewa_karyakarta
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.mahanagar?.kul_sewa_karyakarta}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.totalServiceWork}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="mahanagar.mahanagar_mein_kul_sewa_kary"
                            value={
                              values.mahanagar.mahanagar_mein_kul_sewa_kary
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.mahanagar?.mahanagar_mein_kul_sewa_kary &&
                              !!errors.mahanagar?.mahanagar_mein_kul_sewa_kary
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.mahanagar?.mahanagar_mein_kul_sewa_kary}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.monthlyContactNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="mahanagar.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya"
                            value={
                              values.mahanagar
                                .masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.mahanagar
                                ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya &&
                              !!errors.mahanagar
                                ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.mahanagar
                                ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.kulMahanagariyNagarSankhya}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="mahanagar.kul_mahanagariy_nagar_sankhya"
                            value={
                              values.mahanagar.kul_mahanagariy_nagar_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.mahanagar
                                ?.kul_mahanagariy_nagar_sankhya &&
                              !!errors.mahanagar?.kul_mahanagariy_nagar_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.mahanagar?.kul_mahanagariy_nagar_sankhya}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {
                              fieldLabels[language]
                                ?.sevaKaryayuktMahanagariyNagarSankhya
                            }
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="mahanagar.seva_karyayukt_mahanagariy_nagar_sankhya"
                            value={
                              values.mahanagar
                                .seva_karyayukt_mahanagariy_nagar_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.mahanagar
                                ?.seva_karyayukt_mahanagariy_nagar_sankhya &&
                              !!errors.mahanagar
                                ?.seva_karyayukt_mahanagariy_nagar_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.mahanagar
                                ?.seva_karyayukt_mahanagariy_nagar_sankhya
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {/* Jila Kendra Section */}
                <Row className="mt-3">
                  <Col>
                    <h2>{fieldLabels[language]?.jilaKendra}</h2>
                    <Row>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.districtNumberJilaKendra}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="jilaKendra.zila_sam_jila_kendra_bhag_sankhya"
                            value={
                              values.jilaKendra
                                .zila_sam_jila_kendra_bhag_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.jilaKendra
                                ?.zila_sam_jila_kendra_bhag_sankhya &&
                              !!errors.jilaKendra
                                ?.zila_sam_jila_kendra_bhag_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.jilaKendra
                                ?.zila_sam_jila_kendra_bhag_sankhya
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.settlementNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="jilaKendra.inmein_sewa_basti_sankhya"
                            value={values.jilaKendra.inmein_sewa_basti_sankhya}
                            onChange={handleChange}
                            isInvalid={
                              touched.jilaKendra?.inmein_sewa_basti_sankhya &&
                              !!errors.jilaKendra?.inmein_sewa_basti_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.jilaKendra?.inmein_sewa_basti_sankhya}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.serviceSettlementNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="jilaKendra.sewa_kary_yukt_sewa_basti"
                            value={values.jilaKendra.sewa_kary_yukt_sewa_basti}
                            onChange={handleChange}
                            isInvalid={
                              touched.jilaKendra?.sewa_kary_yukt_sewa_basti &&
                              !!errors.jilaKendra?.sewa_kary_yukt_sewa_basti
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.jilaKendra?.sewa_kary_yukt_sewa_basti}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.businessCollegeNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="jilaKendra.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya"
                            value={
                              values.jilaKendra
                                .vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.jilaKendra
                                ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya &&
                              !!errors.jilaKendra
                                ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.jilaKendra
                                ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.settlementBranchNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="jilaKendra.sewa_basti_palak_shakha_w_milan_sankhya"
                            value={
                              values.jilaKendra
                                .sewa_basti_palak_shakha_w_milan_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.jilaKendra
                                ?.sewa_basti_palak_shakha_w_milan_sankhya &&
                              !!errors.jilaKendra
                                ?.sewa_basti_palak_shakha_w_milan_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.jilaKendra
                                ?.sewa_basti_palak_shakha_w_milan_sankhya
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.serviceWorkerBranchNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="jilaKendra.sewa_karyakarta_yukt_shakha_w_milan_sankhya"
                            value={
                              values.jilaKendra
                                .sewa_karyakarta_yukt_shakha_w_milan_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.jilaKendra
                                ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya &&
                              !!errors.jilaKendra
                                ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.jilaKendra
                                ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.totalServiceWorkers}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="jilaKendra.kul_sewa_karyakarta"
                            value={values.jilaKendra.kul_sewa_karyakarta}
                            onChange={handleChange}
                            isInvalid={
                              touched.jilaKendra?.kul_sewa_karyakarta &&
                              !!errors.jilaKendra?.kul_sewa_karyakarta
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.jilaKendra?.kul_sewa_karyakarta}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.totalServiceWorkJilaKendra}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="jilaKendra.jila_kendra_mein_kul_sewa_kary"
                            value={
                              values.jilaKendra.jila_kendra_mein_kul_sewa_kary
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.jilaKendra
                                ?.jila_kendra_mein_kul_sewa_kary &&
                              !!errors.jilaKendra
                                ?.jila_kendra_mein_kul_sewa_kary
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.jilaKendra?.jila_kendra_mein_kul_sewa_kary}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.monthlyContactNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="jilaKendra.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya"
                            value={
                              values.jilaKendra
                                .masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.jilaKendra
                                ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya &&
                              !!errors.jilaKendra
                                ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.jilaKendra
                                ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.kulKhand}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="jilaKendra.kul_khand"
                            value={values.jilaKendra.kul_khand}
                            onChange={handleChange}
                            isInvalid={
                              touched.jilaKendra?.kul_khand &&
                              !!errors.jilaKendra?.kul_khand
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.jilaKendra?.kul_khand}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.sevaYuktKhand}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="jilaKendra.seva_yukt_khand"
                            value={values.jilaKendra.seva_yukt_khand}
                            onChange={handleChange}
                            isInvalid={
                              touched.jilaKendra?.seva_yukt_khand &&
                              !!errors.jilaKendra?.seva_yukt_khand
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.jilaKendra?.seva_yukt_khand}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {/* Anya Nagar Section */}
                <Row className="mt-3">
                  <Col>
                    <h2>{fieldLabels[language]?.anyaNagar}</h2>
                    <Row>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.districtNumberAnyaNagar}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="anyaNagar.zila_sam_anya_nagar_bhag_sankhya"
                            value={
                              values.anyaNagar.zila_sam_anya_nagar_bhag_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.anyaNagar
                                ?.zila_sam_anya_nagar_bhag_sankhya &&
                              !!errors.anyaNagar
                                ?.zila_sam_anya_nagar_bhag_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.anyaNagar?.zila_sam_anya_nagar_bhag_sankhya}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.settlementNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="anyaNagar.inmein_sewa_basti_sankhya"
                            value={values.anyaNagar.inmein_sewa_basti_sankhya}
                            onChange={handleChange}
                            isInvalid={
                              touched.anyaNagar?.inmein_sewa_basti_sankhya &&
                              !!errors.anyaNagar?.inmein_sewa_basti_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.anyaNagar?.inmein_sewa_basti_sankhya}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.serviceSettlementNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="anyaNagar.sewa_kary_yukt_sewa_basti"
                            value={values.anyaNagar.sewa_kary_yukt_sewa_basti}
                            onChange={handleChange}
                            isInvalid={
                              touched.anyaNagar?.sewa_kary_yukt_sewa_basti &&
                              !!errors.anyaNagar?.sewa_kary_yukt_sewa_basti
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.anyaNagar?.sewa_kary_yukt_sewa_basti}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.businessCollegeNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="anyaNagar.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya"
                            value={
                              values.anyaNagar
                                .vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.anyaNagar
                                ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya &&
                              !!errors.anyaNagar
                                ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.anyaNagar
                                ?.vyavsayee_w_mahawidyalay_shakha_w_milan_sankhya
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.settlementBranchNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="anyaNagar.sewa_basti_palak_shakha_w_milan_sankhya"
                            value={
                              values.anyaNagar
                                .sewa_basti_palak_shakha_w_milan_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.anyaNagar
                                ?.sewa_basti_palak_shakha_w_milan_sankhya &&
                              !!errors.anyaNagar
                                ?.sewa_basti_palak_shakha_w_milan_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.anyaNagar
                                ?.sewa_basti_palak_shakha_w_milan_sankhya
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.serviceWorkerBranchNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="anyaNagar.sewa_karyakarta_yukt_shakha_w_milan_sankhya"
                            value={
                              values.anyaNagar
                                .sewa_karyakarta_yukt_shakha_w_milan_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.anyaNagar
                                ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya &&
                              !!errors.anyaNagar
                                ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.anyaNagar
                                ?.sewa_karyakarta_yukt_shakha_w_milan_sankhya
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.totalServiceWorkers}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="anyaNagar.kul_sewa_karyakarta"
                            value={values.anyaNagar.kul_sewa_karyakarta}
                            onChange={handleChange}
                            isInvalid={
                              touched.anyaNagar?.kul_sewa_karyakarta &&
                              !!errors.anyaNagar?.kul_sewa_karyakarta
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.anyaNagar?.kul_sewa_karyakarta}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.totalServiceWorkAnyaNagar}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="anyaNagar.anya_nagar_mein_kul_sewa_kary"
                            value={
                              values.anyaNagar.anya_nagar_mein_kul_sewa_kary
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.anyaNagar
                                ?.anya_nagar_mein_kul_sewa_kary &&
                              !!errors.anyaNagar?.anya_nagar_mein_kul_sewa_kary
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.anyaNagar?.anya_nagar_mein_kul_sewa_kary}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.monthlyContactNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="anyaNagar.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya"
                            value={
                              values.anyaNagar
                                .masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.anyaNagar
                                ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya &&
                              !!errors.anyaNagar
                                ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.anyaNagar
                                ?.masik_sewa_basti_sampark_karne_wali_shakha_w_milan_sankhya
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {/* Villages Section above 5000 */}
                <Row className="mt-3">
                  <Col>
                    <h2>{fieldLabels[language]?.villagesOver5000}</h2>
                    <Row>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.villagesOver5000}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="villagesOver5000.total_villages"
                            value={values.villagesOver5000.total_villages}
                            onChange={handleChange}
                            isInvalid={
                              touched.villagesOver5000?.total_villages &&
                              !!errors.villagesOver5000?.total_villages
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.villagesOver5000?.total_villages}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.inmeinSevaBastiKiSankhya}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="villagesOver5000.inmein_seva_basti_ki_sankhya"
                            value={
                              values.villagesOver5000
                                .inmein_seva_basti_ki_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.villagesOver5000
                                ?.inmein_seva_basti_ki_sankhya &&
                              !!errors.villagesOver5000
                                ?.inmein_seva_basti_ki_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.villagesOver5000
                                ?.inmein_seva_basti_ki_sankhya
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.businessVillageNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="villagesOver5000.business_and_farming_villages"
                            value={
                              values.villagesOver5000
                                .business_and_farming_villages
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.villagesOver5000
                                ?.business_and_farming_villages &&
                              !!errors.villagesOver5000
                                ?.business_and_farming_villages
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.villagesOver5000
                                ?.business_and_farming_villages
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.serviceVillageNumber}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="villagesOver5000.service_work_villages"
                            value={
                              values.villagesOver5000.service_work_villages
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.villagesOver5000?.service_work_villages &&
                              !!errors.villagesOver5000?.service_work_villages
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.villagesOver5000?.service_work_villages}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {
                              fieldLabels[language]
                                ?.sevaKaryakartaYuktShakhaVaMilanSankhya
                            }
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="villagesOver5000.seva_karyakarta_yukt_shakha_va_milan_sankhya"
                            value={
                              values.villagesOver5000
                                .seva_karyakarta_yukt_shakha_va_milan_sankhya
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.villagesOver5000
                                ?.seva_karyakarta_yukt_shakha_va_milan_sankhya &&
                              !!errors.villagesOver5000
                                ?.seva_karyakarta_yukt_shakha_va_milan_sankhya
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.villagesOver5000
                                ?.seva_karyakarta_yukt_shakha_va_milan_sankhya
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.kulSevaKaryakarta}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="villagesOver5000.kul_seva_karyakarta"
                            value={values.villagesOver5000.kul_seva_karyakarta}
                            onChange={handleChange}
                            isInvalid={
                              touched.villagesOver5000?.kul_seva_karyakarta &&
                              !!errors.villagesOver5000?.kul_seva_karyakarta
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.villagesOver5000?.kul_seva_karyakarta}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.totalServiceInVillages}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="villagesOver5000.total_service_work"
                            value={values.villagesOver5000.total_service_work}
                            onChange={handleChange}
                            isInvalid={
                              touched.villagesOver5000?.total_service_work &&
                              !!errors.villagesOver5000?.total_service_work
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.villagesOver5000?.total_service_work}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6} className="mt-2">
                        <Form.Group>
                          <Form.Label>
                            {
                              fieldLabels[language]
                                ?.masikSevaBastiSamparkKarneWaliShakha
                            }
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="villagesOver5000.masik_seva_basti_sampark_karne_wali_shakha"
                            value={
                              values.villagesOver5000
                                .masik_seva_basti_sampark_karne_wali_shakha
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.villagesOver5000
                                ?.masik_seva_basti_sampark_karne_wali_shakha &&
                              !!errors.villagesOver5000
                                ?.masik_seva_basti_sampark_karne_wali_shakha
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {
                              errors.villagesOver5000
                                ?.masik_seva_basti_sampark_karne_wali_shakha
                            }
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {/* Villages Section below 5000 */}
                <Row className="mt-3">
                  <Col>
                    <h2>{fieldLabels[language]?.villagesUnder5000}</h2>
                    <Row>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.villagesUnderess5000}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="villagesUnder5000.service_work_villages"
                            value={
                              values.villagesUnder5000.service_work_villages
                            }
                            onChange={handleChange}
                            isInvalid={
                              touched.villagesUnder5000
                                ?.service_work_villages &&
                              !!errors.villagesUnder5000?.service_work_villages
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.villagesUnder5000?.service_work_villages}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label>
                            {fieldLabels[language]?.totalServiceInVillages}
                          </Form.Label>
                          <Form.Control
                            type="number"
                            placeholder="Enter number"
                            name="villagesUnder5000.total_service_work"
                            value={values.villagesUnder5000.total_service_work}
                            onChange={handleChange}
                            isInvalid={
                              touched.villagesUnder5000?.total_service_work &&
                              !!errors.villagesUnder5000?.total_service_work
                            }
                            disabled={
                              userType === "kshetra" || userType === "kendra"
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.villagesUnder5000?.total_service_work}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {/* Seva Shikshan Karya Vritt Section */}
                <h2 className="Prapatra">
                  {fieldLabels[language].sevaShikshanWorkReport}
                </h2>
                <Row className="mt-4">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        {fieldLabels[language].sevaSanskar1}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter number"
                        name="sevaShikshanKaryaVritt.seva_sanskar_1"
                        value={values.sevaShikshanKaryaVritt.seva_sanskar_1}
                        onChange={handleChange}
                        isInvalid={
                          touched.sevaShikshanKaryaVritt?.seva_sanskar_1 &&
                          !!errors.sevaShikshanKaryaVritt?.seva_sanskar_1
                        }
                        disabled={
                          userType === "kshetra" || userType === "kendra"
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.sevaShikshanKaryaVritt?.seva_sanskar_1}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        {fieldLabels[language].sevaSanskar2}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter number"
                        name="sevaShikshanKaryaVritt.seva_sanskar_2"
                        value={values.sevaShikshanKaryaVritt.seva_sanskar_2}
                        onChange={handleChange}
                        isInvalid={
                          touched.sevaShikshanKaryaVritt?.seva_sanskar_2 &&
                          !!errors.sevaShikshanKaryaVritt?.seva_sanskar_2
                        }
                        disabled={
                          userType === "kshetra" || userType === "kendra"
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.sevaShikshanKaryaVritt?.seva_sanskar_2}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        {fieldLabels[language].augustSeptember}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter number"
                        name="sevaShikshanKaryaVritt.august_september"
                        value={values.sevaShikshanKaryaVritt.august_september}
                        onChange={handleChange}
                        isInvalid={
                          touched.sevaShikshanKaryaVritt?.august_september &&
                          !!errors.sevaShikshanKaryaVritt?.august_september
                        }
                        disabled={
                          userType === "kshetra" || userType === "kendra"
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.sevaShikshanKaryaVritt?.august_september}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        {fieldLabels[language].branchesVisiting6Plus}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter number"
                        name="sevaShikshanKaryaVritt.branches_visiting_6_plus"
                        value={
                          values.sevaShikshanKaryaVritt.branches_visiting_6_plus
                        }
                        onChange={handleChange}
                        isInvalid={
                          touched.sevaShikshanKaryaVritt
                            ?.branches_visiting_6_plus &&
                          !!errors.sevaShikshanKaryaVritt
                            ?.branches_visiting_6_plus
                        }
                        disabled={
                          userType === "kshetra" || userType === "kendra"
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {
                          errors.sevaShikshanKaryaVritt
                            ?.branches_visiting_6_plus
                        }
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        {
                          fieldLabels[language]
                            .branchesConductingServiceActivities
                        }
                      </Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter number"
                        name="sevaShikshanKaryaVritt.branches_conducting_service_activities"
                        value={
                          values.sevaShikshanKaryaVritt
                            .branches_conducting_service_activities
                        }
                        onChange={handleChange}
                        isInvalid={
                          touched.sevaShikshanKaryaVritt
                            ?.branches_conducting_service_activities &&
                          !!errors.sevaShikshanKaryaVritt
                            ?.branches_conducting_service_activities
                        }
                        disabled={
                          userType === "kshetra" || userType === "kendra"
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {
                          errors.sevaShikshanKaryaVritt
                            ?.branches_conducting_service_activities
                        }
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        {
                          fieldLabels[language]
                            .numberOfServiceActivitiesConducted
                        }
                      </Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter number"
                        name="sevaShikshanKaryaVritt.number_of_service_activities_by_branch"
                        value={
                          values.sevaShikshanKaryaVritt
                            .number_of_service_activities_by_branch
                        }
                        onChange={handleChange}
                        isInvalid={
                          touched.sevaShikshanKaryaVritt
                            ?.number_of_service_activities_by_branch &&
                          !!errors.sevaShikshanKaryaVritt
                            ?.number_of_service_activities_by_branch
                        }
                        disabled={
                          userType === "kshetra" || userType === "kendra"
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {
                          errors.sevaShikshanKaryaVritt
                            ?.number_of_service_activities_by_branch
                        }
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>
                        {fieldLabels[language].serviceInitiativeBranch}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter number"
                        name="sevaShikshanKaryaVritt.service_initiative_branch"
                        value={
                          values.sevaShikshanKaryaVritt
                            .service_initiative_branch
                        }
                        onChange={handleChange}
                        isInvalid={
                          touched.sevaShikshanKaryaVritt
                            ?.service_initiative_branch &&
                          !!errors.sevaShikshanKaryaVritt
                            ?.service_initiative_branch
                        }
                        disabled={
                          userType === "kshetra" || userType === "kendra"
                        }
                      />
                      <Form.Control.Feedback type="invalid">
                        {
                          errors.sevaShikshanKaryaVritt
                            ?.service_initiative_branch
                        }
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                {/* Final Submit Button at bottom */}
                <Row className="mt-4">
                  <Col className="text-center">
                    <Button
                      type="submit"
                      className="submit_buttons"
                      disabled={userType === "kshetra" || userType === "kendra"}
                    >
                      {userType === "vibhag" || userType === "prant"
                        ? `${fieldLabels[language]?.SaveAsSubmit}`
                        : `${fieldLabels[language]?.Submit}`}
                    </Button>
                  </Col>
                </Row>
              </form>
            )}
          </Formik>
        </Container>
      </div>
    </>
  );
};

export default Jilareport;
